const pearl = {
  title: 'لؤلؤة',
  tips: 'يرجى التحقق من معلومات سحب المال والمبلغ',
  notice: 'لا يُسمح بالإلغاء بعد التقديم. يرجى التحقق من دقة تفاصيل الحساب والمبلغ.',
  selectUserTips: 'أدخل المبلغ المراد سحبه',
};

const information = {
  title: 'المعلومات',
  inputPlaceholder: 'دخل',
};

export default {
  title: 'سحب المال',
  success: 'تأكيد بنجاح',
  successTips1: 'سيستغرق الطلب من 3 إلى 7 أيام عمل للمعالجة. يرجى التحلي بالصبر.',
  successTips2: 'إذا تم رفض المراجعة الرسمية، فستتلقى إشعارًا وسيتم رد المبلغ.',
  placeholder: 'أدخل المبلغ المراد سحبه',
  withdrawInformation: 'معلومات سحب المال',
  fee: 'الرسوم: {{count}}%',
  pearl,
  information,
};
